import React from "react";
import { Route, Redirect } from "react-router-dom";
import useAuth from "../hooks/useAuth";
import { useState } from "react";
import { useEffect } from "react";
import { getACDetailByRouteName } from "../apis/shared.api";

export const isFullAccess = (permissions) => {
  if (!permissions.length) return true; // * supper admin

  return false;
};

export const isAccessRoute = (permissions, allowedPermissions) => {
  // * Nếu access control không có permission => return true
  if (!allowedPermissions.length) {
    return true;
  }

  // * Nếu là role Admin thì được quyền try cập tất cả access control.
  if (isFullAccess(permissions)) {
    return true;
  }

  // return permissions
  //   ? permissions.find((permission) =>
  //       allowedPermissions.includes(permission.id)
  //     )
  //   : false;

  return permissions
    ? permissions.find((permission) =>
        allowedPermissions.find(
          (allowPermission) => allowPermission.id === permission.id
        )
      )
    : false;
};

const ProtectedRoutes = ({ component: Component, allowedRoles, ...rest }) => {
  const [loading, setLoading] = useState(true);
  const [permissionRoute, setPermissionRoute] = useState([]);

  useEffect(() => {
    // let isCancelled = false;
    // if (!isCancelled) {
    // }
    // const routeName = `/${rest.location.pathname.split("/")[1]}`;
    const routeName = rest.location.pathname;
    getACDetailByRouteName(routeName, (result) => {
      setPermissionRoute(result?.permissions ? result.permissions : []);
      setLoading(false);
    });
  }, [rest.location.pathname]);

  const { auth } = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  }
  return (
    <Route
      {...rest}
      render={(props) => {
        if (
          isFullAccess(auth?.roles) ||
          isAccessRoute(auth?.permissions, permissionRoute)
        ) {
          return <Component {...props} title={rest.title} />;
        } else {
          return (
            <Redirect
              to={{
                pathname: "/",
                state: {
                  from: props.location,
                },
              }}
            />
          );
        }
      }}
    />
  );
};

export default ProtectedRoutes;
